import IdentityTestPage from "./pages/IdentityTestPage.vue";
import IdentityUserInfoPage from "./pages/IdentityUserInfoPage.vue";
import IdetityManagerListPage from "./pages/IdetityManagerListPage.vue";
export default {
    IdentityTestPage,
    IdentityUserInfoPage,
    IdetityManagerListPage
};
